const updatedDiff = (lhs: any, rhs: any) => {
  if (lhs === rhs) return {};

  if (!isObject(lhs) || !isObject(rhs)) return rhs;

  const l = lhs;
  const r = rhs;

  return Object.keys(r).reduce((acc, key) => {
    if (hasOwnProperty(l, key)) {
      const difference = updatedDiff(l[key], r[key]);

      // If the difference is empty, and the lhs is an empty object or the rhs is not an empty object
      if (isEmptyObject(difference)
           && (isEmptyObject(l[key]) || !isEmptyObject(r[key]))) return acc; // return no diff

      acc[key] = difference;
      return acc;
    }

    return acc;
  }, {});
};


export const isEmpty = (o: any): boolean => Object.keys(o).length === 0;
export const isObject = (o: any) => o !== null && typeof o === 'object';
/* eslint-disable */
export const hasOwnProperty = (o: any, ...args: any): boolean => Object.prototype.hasOwnProperty.call(o, ...args); // eslint-disable-line
export const isEmptyObject = (o: any) => isObject(o) && isEmpty(o);

export default updatedDiff;
